import React from "react";
import "bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";

const Comment = (props) => {
    return (
        <div className="commentContainer">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">{props.name}</h5>
                    <p className="card-text">{props.comment}</p>
                </div>
            </div>
        </div>
    );
}

export default Comment;